<!--
 * @FilePath: ArticleList.vue
 * @Author: 孙新宇
 * @Date: 2022-12-27 10:01:24
 * @LastEditTime: 2022-12-31 15:07:16
 * @Descripttion: 
-->
<!--  -->
<template>
  <div style="width: 100%">
    <!-- 导航栏 S -->
    <van-nav-bar
      :title="title"
      fixed="true"
      placeholder="true"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onReset"
    >
      <template #right>
        <van-icon name="replay" size="18" />
      </template>
    </van-nav-bar>
    <!-- 导航栏 E -->

    <!-- 分类标签选择层 S -->
    <van-dropdown-menu active-color="#1989fa">
      <van-dropdown-item v-model="value" :options="option" />
      <van-dropdown-item title="标签" ref="item">
        <van-search
          v-model="tag_value"
          placeholder="输入并搜索 标签"
          @search="onTagSearch"
        />
        <div>
          <van-cell
            center
            v-for="item in tag_list"
            :key="item.value"
            :title="item.text"
          >
            <template #right-icon>
              <van-switch
                v-model="switchList[item.value]"
                size="24"
                active-color="#1989fa"
              />
            </template>
          </van-cell>
        </div>
        <van-pagination
          v-model="currentPage"
          force-ellipses
          :total-items="totalTag"
          items-per-page="5"
          @change="changePage"
        />
        <div style="padding: 10px 30px; display: flex">
          <van-button type="info" block round @click="onConfirm">
            确 认
          </van-button>
        </div>
      </van-dropdown-item>
    </van-dropdown-menu>
    <!-- 分类标签选择层 E -->

    <!-- 搜索栏 S -->
    <van-search
      v-model="search_value"
      placeholder="输入并搜索 文章名"
      @search="onSearch"
    />
    <!-- 搜索栏 E -->

    <!-- 文章列表 S -->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-card
        v-for="item in list"
        :key="item.id"
        :title="item.title"
        :thumb="item.first_image || img"
        @click="detail(item)"
      >
        <template #tags>
          <div style="margin-top: 12px">
            <div>作者:{{ item.author }}</div>
            <div style="margin-top: 3px">分类:{{ item.classify }}</div>
            <div style="margin-top: 6px">
              <van-icon name="clock-o" />:{{ item.create_time }}
            </div>
          </div>
        </template>
      </van-card>
    </van-list>
    <!-- 文章列表 E -->
  </div>
</template>

<script>
import Vue from "vue";
import { suntae_axios } from "../http/index.js";
import {
  NavBar,
  Toast,
  List,
  Cell,
  Card,
  Icon,
  Popup,
  Search,
  Picker,
  Button,
  DropdownMenu,
  DropdownItem,
  Switch,
  Pagination,
  Dialog,
} from "vant";
import img from "../assets/images/noImg.png";

Vue.use(Pagination);
Vue.use(Switch);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Button);
Vue.use(Picker);
Vue.use(Search);
Vue.use(Popup);
Vue.use(Icon);
Vue.use(Card);
Vue.use(Cell);
Vue.use(List);
Vue.use(NavBar);
Vue.use(Toast);

export default {
  name: "ArticleList",
  props: ["category"],
  data() {
    return {
      title: "", // 导航栏标题
      search_value: "", // 文章搜索内容
      img: img, // 列表默认图片

      //---------文章列表------------
      list: [], // 用于渲染的文章列表
      tempList: [], // 新请求的文章列表
      loading: false, // 列表-加载状态
      finished: false, // 列表-完成状态

      //---------标签------------
      tag_value: "", // 标签搜索内容
      tag_list: [], // 当前页标签
      currentPage: 1, // 标签搜索-当前页码
      switchList: {}, // 标签开关状态
      totalTag: 0,
      tagParams: {
        label: "",
        page: 1,
        size: 5,
      },

      //----------分类-----------
      value: 0, // 分类状态
      option: [{ text: "全部分类", value: 0 }], // 分类列表

      //---------列表请求参数------------
      listParams: {
        title: "", // 标题
        label: "", // 标签
        classify: "", // 分类
        page: 1,
        size: 10,
      },
    };
  },
  methods: {
    //-----------返回-----------
    onClickLeft() {
      // Toast("返回");
      this.$router.go(-1);
    },

    //---------列表加载-------------
    async onLoad() {
      // 请求数据后 page+1
      let responce = await this.request_list();
      this.listParams.page++;

      this.tempList = responce.result;
      // console.log(this.tempList);

      this.list = [...this.list, ...this.tempList];
      // console.log(this.list);

      // 加载状态结束
      this.loading = false;

      // 数据全部加载完成
      if (this.tempList.length == 0) {
        this.finished = true;
      }
    },

    //----------请求文章列表------------
    request_list() {
      if (this.category == 1) {
        return suntae_axios(
          "/api/help_manual/user_manual/get_list",
          this.listParams
        );
      } else if (this.category == 2) {
        return suntae_axios(
          "/api/help_manual/common_problem/get_list",
          this.listParams
        );
      } else {
        return suntae_axios(
          "/api/help_manual/vehicle_debugging/get_list",
          this.listParams
        );
      }
    },

    //----------请求标签列表------------
    request_tag_list() {
      // 获取标签列表
      suntae_axios(
        "/api/help_manual/common_problem/get_label_drop_list",
        this.tagParams
      ).then((res) => {
        this.tag_list = res.result;

        this.totalTag = res.length;

        this.tag_list.forEach((item) => {
          if (this.switchList[item.value] == undefined) {
            this.$set(this.switchList, item.value, false);
          }
        });

        console.log("this.switchList", this.switchList);
      });
    },

    //-----------清空列表-----------
    clearList() {
      this.list = [];
      this.listParams.page = 1;
      this.finished = false;
    },

    //-----------重置搜索-----------
    onReset() {
      Dialog.confirm({
        title: "提示",
        message: "确定要重置搜索吗?",
      })
        .then(() => {
          // on confirm
          this.list = [];
          this.search_value = "";
          this.tag_value = "";
          this.value = 0;
          this.currentPage = 1;
          this.listParams = {
            title: "",
            label: "",
            classify: "",
            page: 1,
            size: 10,
          };
          this.finished = false;
          this.totalTag = 0;
          this.tagParams = {
            label: "",
            page: 1,
            size: 5,
          };
          this.switchList = {};

          // 重置后需马上发送请求
          this.clearList();

          this.initTag();
        })
        .catch(() => {
          // on cancel
        });
    },

    //----------搜索文章标题------------
    onSearch() {
      this.clearList();

      this.listParams.title = this.search_value;
    },

    //-----------初始化分类-----------
    initClass() {
      suntae_axios(
        "/api/help_manual/common_problem/get_article_classify_list"
      ).then((res) => {
        this.option = [...this.option, ...res.result];
        console.log(this.option);
      });
    },

    //-----------初始化标签-----------
    initTag() {
      // 获取标签列表
      suntae_axios(
        "/api/help_manual/common_problem/get_label_drop_list",
        this.tagParams
      ).then((res) => {
        this.tag_list = res.result;

        this.totalTag = res.length;

        this.switchList = {};

        this.tag_list.forEach((item) => {
          this.$set(this.switchList, item.value, false);
        });

        console.log("this.switchList", this.switchList);
      });
    },

    //-----------搜索标签-----------
    onTagSearch() {
      // Toast(this.tag_value);

      this.tagParams.label = this.tag_value;

      this.tagParams.page = 1;

      this.currentPage = 1;

      this.request_tag_list();
    },

    //----------翻页------------
    changePage() {
      this.tagParams.page = this.currentPage;

      this.request_tag_list();
    },

    //-----------标签筛选确定-----------
    onConfirm() {
      let tempTag = [];

      Object.keys(this.switchList).forEach((key) => {
        // console.log(key, this.switchList[key]);
        if (this.switchList[key]) {
          tempTag.push(key);
        }
      });

      this.listParams.label = tempTag.join();

      console.log(this.listParams.label);

      this.clearList();

      this.$refs.item.toggle();
    },

    //----------进入文章详情页------------
    detail(id) {
      this.$router.push({ name: "detail", params: { id: id } });
    },
  },
  mounted() {
    if (this.category == 1) {
      this.title = "使用手册";
      // this.option[0] = { text: "使用手册", value: 0 };
    } else if (this.category == 2) {
      this.title = "常见问题";
      // this.initClass();
    } else {
      this.title = "车辆排障";
      // this.initClass();
    }

    // 获取分类列表
    this.initClass();

    // 获取标签列表
    this.initTag();
  },
  // updated() {
  //   if (this.category == 1) {
  //     this.title = "使用手册";
  //     this.option[0] = { text: "使用手册", value: 0 };
  //   } else if (this.category == 2) {
  //     this.title = "常见问题";
  //     this.initClass();
  //   } else {
  //     this.title = "车辆排障";
  //     this.initClass();
  //   }

  //   // 获取标签列表
  //   this.initTag();
  // },
  watch: {
    value: function (newValue) {
      this.listParams.classify = newValue;

      this.clearList();

      // this.onLoad();
    },
  },
};
</script>
<style scoped>
/* @import url(); 引入css类 */
.van-card {
  background-color: #f4f4f4;
}
.van-card__title {
  font-size: 15px !important;
  font-weight: 600;
  margin-top: 2px;
}
</style>